import { create } from "zustand";

export type RightDrawerTab = "agent" | "terminal";

interface RightDrawerTabState {
	activeTab: RightDrawerTab;
	setActiveTab: (tab: RightDrawerTab) => void;
}

export const useRightDrawerTabStore = create<RightDrawerTabState>((set) => ({
	activeTab: "agent",
	setActiveTab: (tab) => set({ activeTab: tab }),
}));
